var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('healthcheck-form',{attrs:{"healthcheck-id":_vm.healthcheckId,"details":"","cloned":""},on:{"submit":_vm.addHealthcheck,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }